module.exports = __webpack_public_path__ + "img/Group120.b31df677.png";